import React from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useGetSubscriptionUserByIdQuery } from "../subscription-users.service";
import SubscriptionUserDetails from "../components/subscription-user-details";
import PageLoading from "src/components/pageLoading";
import { appendSearchToPath } from "src/customHooks/usePaginatedTableSearchParams";

const SubscriptionUserDetailsPage = () => {
  const { id } = useParams<{ id: string }>();
  const location = useLocation();
  const navigate = useNavigate();
  const backToSubscriptionUsers = appendSearchToPath("/subscription-users", location.search);
  
  const { data: subscriptionUser, isLoading, isError, error } = useGetSubscriptionUserByIdQuery(id!);

  const handleBack = () => {
    navigate(backToSubscriptionUsers);
  };

  if (isLoading) {
    return <PageLoading />;
  }

  if (isError || !subscriptionUser) {
    return (
      <div className="container mx-auto px-4 py-8">
        <div className="max-w-4xl mx-auto">
          <div className="bg-red-50 border border-red-200 rounded-lg p-6 text-center">
            <h3 className="text-lg font-semibold text-red-800 mb-2">Error Loading Subscription User</h3>
            <p className="text-red-600 mb-4">
              {error ? `Error: ${JSON.stringify(error)}` : "Subscription user not found or user does not have an active subscription."}
            </p>
            <button
              onClick={handleBack}
              className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors"
            >
              Back to Subscription Users
            </button>
          </div>
        </div>
      </div>
    );
  }

  return <SubscriptionUserDetails subscriptionUser={subscriptionUser} onBack={handleBack} />;
};

export default SubscriptionUserDetailsPage;
